import { ActivableModel } from '@app/core/models/shared/activable.model';
import { GroupTypeModel } from '@app/core/models/groups/group-type.model';
import { UserDetailModel } from '@app/core/models/users/user-detail.model';

export class GroupModel extends ActivableModel {
  constructor(
    public Id?: number,
    public Name?: string,
    public Type?: string,
    public Users?: UserDetailModel[],
    public TypeId?: GroupTypeModel,
    public SupervisorUserId?: string,
    public SupervisorUser?: string,
    public ProfessionType?: number | null,
    public IsVoucher?: boolean | null,
    public VoucherDepartment?: string,
    public VoucherAnalyticalSection?: string,
    public VoucherAnalyticalCode?: string,
    public VoucherComment?: string,
    public LinkedGroupId?: string,
    public IsLinked?: boolean,
    public CanCreateInPPR?: boolean,
    public IsPrescriptorGroup?: boolean,
    public CanManageInvoiceAGI?: boolean,
    public CompanyCode?: string,
    public CompanyLabel?: string,
    public Typology?: number,
    public TypologyLabel?: string,
    public TreeLevelValue?: string
  ) {
    super();
  }
}
